module.exports = __webpack_public_path__ + "img/img01.5eeacbb8.png";